<template>
  <div class="main">
    <my_menu2 v-if="project_name" :page_name="project_name + '-项目合同列表'" back_type="close" back_icon="md-close">
    </my_menu2>

    <!-- <div class="page_title">
      <span> {{ project_name }}-项目合同列表 </span>

      <div>
         <span class="roster_template_name" title="模板选择后不可修改">当前模板: {{ roster_template_info.name }}</span> 
      </div>
    </div> -->

    <div class="entry_status_div">
      <Tabs v-model="entry_status" size="small" @on-click="click_tabs">
        <TabPane label="在职" name="0"></TabPane>
        <TabPane label="离职" name="1"></TabPane>
      </Tabs>

      <div>
        <Button :loading="down_loading" @click="export_contract(1)" style="font-size: 12px; margin-right: 5px"
          size="small">
          <Icon type="ios-cloud-download-outline" /> 仅导出Excel
        </Button>

        <Button :loading="down_loading" @click="export_contract(0)" style="font-size: 12px" size="small">
          <Icon type="ios-cloud-download-outline" /> 批量下载含合同文件
        </Button>
      </div>
    </div>

    <div class="table_box">
      <Spin fix v-if="loading"></Spin>

      <Table @on-selection-change="selection_change" :height="windowHeight - 100" :columns="columns" :data="table_data"
        size="small">
        <template #name="{ row }">
          <span class="name" @click="click_name(row)">{{ row.name }}</span>
        </template>
        <template #flow_status="{ row }">
          <span class="flow_status" :style="'background-color:' + row.flow_status_color">{{ row.flow_status }}</span>
        </template>
        <template #flow_list="{ row }">
          <div class="flow_list">
            <div :title="item.time" v-for="(item, i) in row.flow_list" :key="i"
              :class="item.checked ? 'flow_tag' : 'flow_tag2'">
              {{ item.title }}
            </div>
          </div>
        </template>
        <template #finish_status="{ row }">
          <div :class="row.finish_status == 2 ? 'finish_status_msg' : 'finish_status_msg2'">
            {{ row.finish_status_msg }}
          </div>
        </template>
        <template #audit_status="{ row }">
          <div class="finish_status_msg" v-if="row.audit_status == 0">待审核</div>
          <div class="finish_status_msg" v-if="row.audit_status == 1">已通过</div>
          <div class="finish_status_msg2" v-if="row.audit_status == 2">未通过</div>
        </template>
        <template #is_revoke="{ row }">
          <div class="finish_status_msg" v-if="row.is_revoke == 0">流程正常</div>
          <div class="finish_status_msg2" v-if="row.is_revoke == 1">已撤销</div>
        </template>
        <template #audit_error_remarks="{ row }">
          <div class="ellipsis" @click="view_audit_error_remarks(row.audit_error_remarks)">
            <span :title="row.audit_error_remarks">{{ row.audit_error_remarks }}</span>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import my_menu2 from "@/component/menu/menu2.vue";

export default {
  components: { my_menu2 },
  data() {
    return {
      project_id: "",
      project_name: "",
      table_data: [],
      columns: [],
      loading: false,
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      entry_status: "0",
      down_loading: false,
      selection_data: [],
    };
  },
  mounted() {
    //
    var that = this;
    var query = this.$route.query;
    this.project_id = query.project_id;
    this.entry_status = query.entry_status;

    if (!this.project_id) {
      alert("参数异常");
    }

    this.get_contract_list();

    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
        console.log("宽高变化", that.windowHeight, that.windowWidth);
      })();
    };
  },
  methods: {
    view_audit_error_remarks(content) {
      this.$Modal.info({
        title: '不通过原因',
        content: content
      });
    },
    click_tabs() {
      this.get_contract_list();
    },

    click_down(url) {
      open_new_page(url);
    },

    selection_change(e) {
      this.selection_data = e;
    },

    export_contract(status) {
      var that = this;
      if (this.selection_data.length == 0) {
        this.$Message.error("请至少选一位");
        return;
      }

      var idcard_list = [];
      for (let i = 0; i < this.selection_data.length; i++) {
        var idcard = this.selection_data[i]["idcard"];
        idcard_list.push(idcard);
      }
      var _dict = {
        project_id: this.project_id,
        idcard_list: idcard_list,
        export_status: status,
      };
      that.$Message.info("正在下载中，稍等一下哈~");
      that.down_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/contract/export_contract",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.$Modal.confirm({
              title: "导出提示",
              content: "<p>打包导出成功了，请点击确认开始下载</p>",
              onOk: () => {
                that.click_down(res.data.url);
              },
              onCancel: () => { },
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.down_loading = false;
        })
        .catch((res) => {
          that.down_loading = false;
          console.log(res, "请求出错");
        });
    },

    click_name(row) {
      var url =
        "https://contract.daxiangsys.com/contract_manage/search/detail?name=&phone=&idcard=" +
        row.idcard;
      open_new_page(url);
    },

    get_contract_list() {
      var that = this;

      var _dict = {
        project_id: that.project_id,
        status: Number(that.entry_status),
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/contract/project_contract_list",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.table_data = res.data.audit_list;
            that.project_name = res.data.project_name;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          that.loading = false;
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>

.ellipsis {
  width: 100%;
  /* 必须有限定宽度 */
  white-space: nowrap;
  /* 不换行 */
  overflow: hidden;
  /* 超出隐藏 */
  text-overflow: ellipsis;
  /* 省略号 */
  cursor: pointer;
}

.ellipsis:hover {
  color: #006eff;
  font-weight: 600;
}
.flow_status {
  padding: 3px 5px;
  border: 3px;
  color: #fff;
}

.finish_status_msg {
  color: #30aa0e;
}

.finish_status_msg2 {
  color: #fb0026;
}

.entry_status_div {
  padding: 40px 10px 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.name {
  color: #0466dd;
  cursor: pointer;
}

.flow_tag {
  color: #fff;
  background: #276abb;
  padding: 2px 5px;
  cursor: pointer;
  font-size: 10px;
  border-right: 1px solid #ccc;
}

.flow_tag2 {
  cursor: pointer;
  font-size: 10px;
  color: #fff;
  background: #b4b4b4;
  padding: 2px 5px;
  border-right: 1px solid #ccc;
}

.flow_list {
  display: flex;
  align-items: center;
}

.table_box {}

.page_title {
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 3px;
  padding: 0 15px 0 15px;
  background-color: #0466dd;
  color: #fff;
  height: 40px;
  line-height: 40px;
}
</style>
